import { bootstrapApplication } from '@angular/platform-browser';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideHttpClient } from '@angular/common/http';
import { App } from './app/app';
import { provideRouter, Routes } from '@angular/router';
import { DashboardComponent } from './app/components/dashboard/dashboard';
import { ContentInventoryComponent } from './app/components/content-inventory/content-inventory';
import { UrlDetailComponent } from './app/components/url-detail/url-detail';
import { LoginComponent } from './app/components/login/login';
import { RegisterComponent } from './app/components/register/register';
import { AuthGuard } from './app/guards/auth.guard';

// Define app routes for standalone routing
const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'inventory', component: ContentInventoryComponent, canActivate: [AuthGuard] },
  { path: 'inventory/:url', component: UrlDetailComponent, canActivate: [AuthGuard] },
];

bootstrapApplication(App, {
  providers: [
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(),
    provideRouter(routes) // Provide router for standalone app
  ]
}).catch(err => console.error(err));
// TODO: Replace CSV upload with direct GSC integration in the future
